import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=e737c32a&scoped=true&"
import script from "./Impressum.vue?vue&type=script&lang=ts&"
export * from "./Impressum.vue?vue&type=script&lang=ts&"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=e737c32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e737c32a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
